"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  ", "\n  font-weight: ", ";\n  ", ";\n"], ["\n  ", "\n  font-weight: ", ";\n  ", ";\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

var _Heading = require("./Heading");

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HeadingThree = _styledComponents2.default.h3.withConfig({
  displayName: "HeadingThree",
  componentId: "sc-1ef9sl2-0"
})(_templateObject, function (props) {
  return (0, _buoyTheme.fontSize)(props.fontSize)(props);
}, function (props) {
  return props.theme.fonts.weight[props.weight];
}, _Heading2.default);

HeadingThree.defaultProps = {
  color: "neutralDarkest",
  fontSize: "bodyMain",
  weight: "medium"
};

exports.default = HeadingThree;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-text/dist/components/HeadingThree.js
// module id = 450
// module chunks = 168707334958949